import { getAppConfig } from 'aster-foundation/core/astercore/appConfig/redux/actions';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import { debounce } from 'lodash';
import { Container, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { getCategoryTree } from 'aster-foundation/core/epharmacy/Category/redux/action';
import useInactivityTimer  from '@common/Hooks/useInactivityTimer';
import { useAuth } from '@common/AuthService';
import { changeLocationEvent } from 'Homecare/HomecareAnalytics';
import { DOWN_ARROW, IC_LOCATION, IC_PERCENTAGE_OFFER_GREEN } from '../../Assets/images';
import useScrollHandler from '@common/Context/useScrollHandler';
import { errorHandling, setIsInStoreApp, isTopBarDealsVisible, MIN_MOBILE_WIDTH, getIsInstoreApp } from '@common/Utility/common-utils';
import {
  FLAGSMITH_KEYS,
  HOME_CARE_ROUTE,
  LOCALSTORAGE_KEYS,
  ONLINE_PHARMACY_ROUTE,
  REGION_SWITCHER_DISALLOWED_URLS,
} from '@common/Utility/constants';
import { EventEmitter } from '@common/Utility/eventEmitter';
import { HeaderBelowStyled } from './HeaderBelowStyled';
import MegaMenu from './MegaMenu/MegaMenu';
import { setUserLocationData,setSelectedLocationData, setUserArea  } from './redux/reducer';
import { flagsmith } from '@common/Lib/Flagsmith';
import useIsNotSafari from '@common/Utility/hooks';
import { addUserAddress } from 'aster-foundation/core/epharmacy/address/redux/actions';
import { isRTL } from '@common/i18n';
import { getLangCodeFromUrl } from '../../../../i18n';

const SelectLocation = dynamic(() => import('../SelectLocation/SelectLocation'));
const ToastControl = dynamic(() => import('../ToastControl/ToastControl'), {
  ssr: false,
});

const HeaderBelow = (props) => {
  const router = useRouter();
  const { authCtx } = useAuth();
  const lastScrollY = useRef(0);
  const selectedLat = useRef(typeof window !== 'undefined' && localStorage.getItem(LOCALSTORAGE_KEYS.LATITUDE));
  const selectedLong = useRef(typeof window !== 'undefined' && localStorage.getItem(LOCALSTORAGE_KEYS.LONGITUDE));

  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const userLocationData = useSelector((state) => state?.epharmacy?.getUserAddress?.data?.data);
  // const asterSecureLoyaltics = useSelector((state) => state?.astercore?.getLoyaltyData?.data?.data); // TODO:7671 after testing will remove
  const userLocation = useSelector((state) => state?.app?.userLocationReducer);
  const userDefaultLocation = useSelector((state) => state?.epharmacy?.getDefaultLocation?.data?.data);
  const appConfig = useSelector((state) => state?.astercore?.AppConfig?.data?.data);
  const categoryTree = useSelector((state) => state?.epharmacy?.getCategoryTree?.data?.data);
  const [addressPopup, setAddressPopup] = useState(false);
  // const [loyaliticsLinked, setLoyaliticsLinked] = useState(false); // TODO:7671 after testing will remove
  const [currentPage, setCurrentPage] = useState('');
  const [addAddress, setAddAddress] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [isIncreasing, setIsIncreasing] = useState(true);
  const [guestCheckoutProps, setGuestCheckoutProps] =useState({ isAuthenticated: true, ...props.guestCheckoutProps });
  const enableGuestCheckout = flagsmith.getValue('ae_web_guestcheckout', { json: true })?.enableGuestCheckout || getIsInstoreApp();
  const instoreFlag = flagsmith.getValue('ae_web_instore_checkout', { json: true });
  const [isOfferVisible, setIsOfferVisible] = React.useState(
    typeof window !== 'undefined' && sessionStorage.getItem('topBarSession'),
  );
  const [autoSelectAddress, setAutoSelectAddress] = React.useState(
    typeof window !== 'undefined' && sessionStorage.getItem(LOCALSTORAGE_KEYS.AUTOSELECT_ADDRESS),
  );
  const [topBarDealsArray, setIsTopBarDealsArray] = React.useState([]);
  const [categoryList, setCategoryList] = useState([]);
  // const [isAddressEmpty, setIsAddressEmpty] = useState(false); // TODO:7671 after testing will remove
  const [isMobile, setIsMobile] = useState(false);
  const [currentLang, setCurrentLanguage] = useState('');

  const dispatch = useDispatch();
  const scrollY = useScrollHandler();
  const web_feature_flaging = flagsmith.getValue(FLAGSMITH_KEYS.WEB_FEATURE_FLAGING, {json: true});

  const isDisallowedSwitcher = REGION_SWITCHER_DISALLOWED_URLS.some((disallowedPath) => router?.asPath?.split('?')?.[0]?.indexOf(disallowedPath) > -1);

  useEffect(() => {
    if (window.innerWidth <= MIN_MOBILE_WIDTH) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
    if(window !== 'undefined'){
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);

  const checkForCategories = (list) => {
    if (list) {
      return setCategoryList(list?.filter((item) => item?.subCategories));
    }
    return [];
  };

  useEffect(() => {
    const params = {
      level: 2,
      subCategoryLevel: 4,
    };
    if(!categoryTree){
      dispatch(
        getCategoryTree({
          params: params,
          onSuccess: () => {},
          onFailure: () => {
            // toast.error('Something went wrong');
          },
        }),
      );
    }
  }, [userLogin,guestLogin]);

  useEffect(() => {
    checkForCategories(categoryTree)
  }, [categoryTree]);

  const getPreferredAddress = (addresses) => {
    let slectedLatLonAddress = null;
    if(addresses?.length){
      addresses.map((item) => {
        const latLong = item?.latLong?.split(',');
        const lat = latLong?.[0]?.trim();
        const lng = latLong?.[1]?.trim();
        if ( lat === selectedLat?.current && lng === selectedLong?.current ) {
          slectedLatLonAddress = item;
        }
      })
    }
    if(slectedLatLonAddress) return null;
    const selectedAddress = addresses.find((address) => address.selected === true);
    if (selectedAddress) return selectedAddress;    
    const primaryAddress = addresses.find((address) => address.primary === true);
    if (primaryAddress) return primaryAddress;
    return addresses[0];
  };

  const offerCheck = () => {
    sessionStorage.setItem('topBarSession', 'false');
    setIsOfferVisible('false');
  };

  React.useEffect(() => {
    const sessionValue = sessionStorage.getItem('topBarSession');
    if (sessionValue === null) {
      sessionStorage.setItem('topBarSession', 'true');
      setIsOfferVisible('true');
    }

    setIsInStoreApp(instoreFlag);
  }, []);

  React.useEffect(() => {
    const topBarDealsArrayValue = appConfig?.filter((item) => item?.name === 'topBarAttractiveDeals');
    setIsTopBarDealsArray(topBarDealsArrayValue);
  }, [appConfig]);

  // Need to check API aster core
  React.useEffect(() => {
    if ((authCtx?.authenticated || guestLogin || userLogin) && !appConfig) {
      dispatch(
        getAppConfig({
          onSuccess: () => {},
          onFailure: (err) => {
            errorHandling(err, true);
          },
        }),
      );
    }
  }, [guestLogin, userLogin, authCtx?.authenticated]);

  // TODO:7671 after testing will remove
  /* useEffect(() => {
    if (asterSecureLoyaltics) {
      if (asterSecureLoyaltics === 'Link Your Account' || asterSecureLoyaltics === 'Pending Confirmation') {
        setLoyaliticsLinked(true);
      } else {
        setLoyaliticsLinked(false);
      }
    }
  }, [asterSecureLoyaltics]); */

  const openLocationSidebar = (params = { currentpage: '', addAddress: false, showToast: true }) => {
    setAddressPopup(!addressPopup);
    if (params?.currentpage) {
      setCurrentPage(params?.currentpage);
    }
    if (params?.addAddress) {
      setAddAddress(Boolean(params?.addAddress));
    }
    if (params?.showToast){
      setShowToast(Boolean(params?.showToast));
    }
    localStorage.setItem('isLocationPopUp', false);
  };
  const closeAddressPopup = (close = false) => {
    close && EventEmitter.dispatch('address_side_bar_closed');
    setAddressPopup(false);
    setAddAddress(false);
    setCurrentPage('');
  };

  const updateUserLocation = (selectedLocation, closePopup = true) => {
    const lat = selectedLocation?.latLong?.split(/\s+/)?.join('')?.split(',')?.[0];
    const lng = selectedLocation?.latLong?.split(/\s+/)?.join('')?.split(',')?.[1];
    dispatch(
      setUserLocationData({
        lat,
        lng,
      }),
    );

    dispatch(
      setSelectedLocationData({
        selectedLocation
      }),
    );

    EventEmitter.dispatch('setLocation', `${selectedLocation.areaName}, ${selectedLocation.cityName}`);
    EventEmitter.dispatch('setLocationItem', selectedLocation);
    EventEmitter.dispatch('updateUserZone', { latitude: lat, longitude: lng });
    localStorage.setItem('Latitude', lat);
    localStorage.setItem('Longitude', lng);
    localStorage.removeItem('isAddressEmpty');
    closePopup !== false && closeAddressPopup();
  };

  const changeLocation = (lat, lng, closePopup = true) => {
    const defaultLocationStorage = localStorage.getItem('defaultLocation');
    const latlng = defaultLocationStorage?.split(/\s+/)?.join('')?.split(',');
    if (lat && lat?.toString() !== latlng?.[0]?.toString() && lng && lng?.toString() !== latlng?.[1]?.toString()) {
      EventEmitter.dispatch('getLocationName', { latitude: lat, longitude: lng });
    }

    if (enableGuestCheckout) {
      if(!authCtx.authenticated) {
        localStorage.setItem('guestLat', JSON.stringify(lat));
        localStorage.setItem('guestLong', JSON.stringify(lng));
      } else {
        localStorage.removeItem('guestLat');
        localStorage.removeItem('guestLong');
      }
  
      localStorage.removeItem('isAddressEmpty');  
      dispatch(
        setSelectedLocationData({
          selectedLocation: null
        }),
      );
    }
    closePopup !== false && closeAddressPopup();
  };

  const updateSelectedUserAddress = (selectedAddress) => {
    const params = { ...selectedAddress, selected: true };
    dispatch(
      addUserAddress({
        params,
        onSuccess: (response) => {
          dispatch(setUserArea(selectedAddress?.areaName));
          updateUserLocation(selectedAddress);
        },
        onFailure: (err) => {
          console.error('Not able to save/update location', err);
        },
      }),
    );
  };

  useEffect(() => {
    if(autoSelectAddress && userLocationData?.length > 0 ){
      const preferredAddress = getPreferredAddress(userLocationData);
      sessionStorage.removeItem(LOCALSTORAGE_KEYS.AUTOSELECT_ADDRESS);
      setAutoSelectAddress(false);
      if(preferredAddress){
        localStorage.setItem(LOCALSTORAGE_KEYS.PREFERRED_ADDRESS, JSON.stringify(preferredAddress));
        if(getIsInstoreApp()){
          localStorage.setItem(LOCALSTORAGE_KEYS.GUEST_USER_ADDRESS, JSON.stringify(preferredAddress));
        }
        updateSelectedUserAddress(preferredAddress);
      }
    }
  },[autoSelectAddress, userLocationData]);

  useEffect(() => {
    EventEmitter.subscribe('open_location_sidebar', (params) => {
      setGuestCheckoutProps(params);
      openLocationSidebar(params);
    });

    EventEmitter.subscribe('updateUserLocation', (data) => {
      if (data?.location) {
        updateUserLocation(data?.location);
      }
    });
    return () => {
      EventEmitter.unsubscribe('open_location_sidebar', (params) => openLocationSidebar(params));
      EventEmitter.unsubscribe('updateUserLocation', () => {
        updateUserLocation();
      });
    };
  }, []);

  const selectLocationEvent = () => {
    if (router?.pathname?.indexOf(HOME_CARE_ROUTE) > -1) {
      const eventData = {
        screen_name: props?.screenName ? props?.screenName : router?.asPath,
        page_type: props?.history,
      };
      changeLocationEvent(eventData);
    };
  };

  const handleScroll = debounce(() => {
    if (props?.cartPageLoading) {
      return;
    }

    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY.current) {
      setIsIncreasing(true);
    } else if (currentScrollY + 18 < lastScrollY.current) {
      setIsIncreasing(false);
    }

    lastScrollY.current = currentScrollY;
  }, 50);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    if (props?.cartPageLoading) {
      setIsIncreasing(false);
    }
  }, [props?.cartPageLoading]);

  const isActive = getIsInstoreApp() && authCtx?.authenticated;

  useInactivityTimer(
    instoreFlag?.timer || 180000,
    () => {
      if (getIsInstoreApp() && authCtx?.authenticated) {
        authCtx?.logout({callLogoutAPI: true, redirectUri: ONLINE_PHARMACY_ROUTE});
      }
    },
    isActive,
  );
  

  const isNotSafari = useIsNotSafari();

  return (
    <>
      <ToastContainer autoClose={1500} hideProgressBar />
      <HeaderBelowStyled
        className={`
          ${props?.promotionLeafLet 
            ? `${props?.customClass} fixed` 
            : `${props?.customClass} ${!isIncreasing ? 'fixed' : ''}`}
          ${isDisallowedSwitcher ? 'topZero' : ''}
        `}
        
        scrollY={scrollY}
        hideLabel={props?.hideLabel}
        maxWidth={categoryList?.length > 5}
        isNotSafari={isNotSafari}
      >
        {!props.hideLabel && (
          <Container>
            <div className="d-flex align-items-center cursor-pointer">
              {web_feature_flaging?.isLocationEnable &&
                <div className={`borderbrand ${currentLang && isRTL(currentLang) ? 'rtl' : ''}`}>
                  <div className="addressWrapper">
                    <div
                      className="d-inline-flex align-center cursor-pointer"
                      data-test="address-popup"
                      onClick={() => {
                        setAddressPopup(!addressPopup);
                      }}
                    >
                      <Form.Label className="cursor-pointer">
                        <Image src={IC_LOCATION} width="14" height="17" alt={userLocation?.area} priority />
                      </Form.Label>
                      <div className="me-2" onClick={selectLocationEvent}>
                        {userLocation?.area && userLocation?.area.length > 16 ? `${userLocation.area.slice(0, 14)}...` : userLocation?.area}
                      </div>
                      <Image src={DOWN_ARROW} width="10" height="5" alt="Down Arrow Icon" priority />                  
                    </div>
                  </div>
                </div>
              }
              {categoryList?.length > 0 && <MegaMenu categoryList={categoryList} screenName={props?.screenName} pageType={props?.pageType} />}
            </div>
          </Container>
        )}

        {addressPopup && (
          <SelectLocation
            currentPage={currentPage}
            addAddress={addAddress}
            closePopup={() => closeAddressPopup(true)}
            getCurrentLocation={() => {
              EventEmitter.subscribe('getLocation');
            }}
            locationItem={userLocation?.locationItem}
            onChangeLocation={changeLocation}
            updateUserLocation={updateUserLocation}
            appVariant=""
            screenName={props?.screenName}
            pageName={props?.pageType}
            defaultLocationData={userDefaultLocation?.[0]}
            showFullAddress={authCtx?.authenticated}
            showToast={showToast}
            guestCheckoutProps={guestCheckoutProps}
            userId={props?.userId}
            setAddressId={props?.setAddressId}
            setSuccessimage_delivery={props?.setSuccessimage_delivery}
            registeredguest={props?.registeredguest}
            addressId={props?.addressId}
          />
        )}
      </HeaderBelowStyled>
      {/* {keycloak?.authenticated && asterSecureLoyaltics?.availablePoints !== undefined && !props?.hidePointsBox && (
        <PointsBox
          customClass={`noDesktop ${props?.hidePointsBox ? 'noMobile' : ''} `}
          points={asterSecureLoyaltics?.availablePoints ? asterSecureLoyaltics?.availablePoints : '0'}
          AED={asterSecureLoyaltics?.amount ? asterSecureLoyaltics?.amount : '0'}
          userId={userLogin?.id}
        />
      )} */}
      {isOfferVisible === 'true' &&
        isTopBarDealsVisible(router?.pathname) &&
        topBarDealsArray &&
        topBarDealsArray.length > 0 &&
        topBarDealsArray.map((item) => (
          <ToastControl
            text={`<strong>${item?.value} </strong>${item?.description}`}
            variant={`newVariantGreen justify-content-center toast-image ${scrollY > 38 ? 'floating-wrapper' : ''}`}
            imgBox
            imgError={IC_PERCENTAGE_OFFER_GREEN}
            iconWidth="18px"
            iconHeight="18px"
            dismissibleAction={offerCheck}
          />
        ))}
    </>
  );
};

HeaderBelow.propTypes = {
  customClass: PropTypes.string,
  hideLabel: PropTypes.bool,
  screenName: PropTypes.string,
  history: PropTypes.string,
  pageType: PropTypes.string,
};
HeaderBelow.defaultProps = {
  customClass: '',
  hideLabel: false,
  hidePointsBox: false,
  history: '',
  screenName: '',
  pageType: '',
};

export default HeaderBelow;
